/**
 * Author Profile – JSON-LD Parser & Dynamic Renderer
 * Parses Schema.org Person JSON-LD and populates the profile page.
 */
(function () {
  'use strict';

  /* ─── Platform detection for social links ─── */
  var PLATFORMS = [
    { key: 'linkedin',  label: 'LinkedIn',       match: 'linkedin.com',  icon: 'in' },
    { key: 'instagram', label: 'Instagram',       match: 'instagram.com', icon: '\u{1F4F7}' },
    { key: 'amazon',    label: 'Amazon Autor',    match: 'amazon.',       icon: 'a' },
    { key: 'youtube',   label: 'YouTube',         match: 'youtube.com',   icon: '\u25B6' },
    { key: 'twitter',   label: 'Twitter / X',     match: 'twitter.com',   icon: 'X' },
    { key: 'twitter',   label: 'Twitter / X',     match: 'x.com',         icon: 'X' },
    { key: 'facebook',  label: 'Facebook',        match: 'facebook.com',  icon: 'f' },
    { key: 'xing',      label: 'XING',            match: 'xing.com',      icon: 'X' },
    { key: 'forbes',    label: 'Forbes',           match: 'forbes.com',    icon: 'F' },
    { key: 'thalia',    label: 'Thalia Autor',     match: 'thalia.de',     icon: 'T' },
    { key: 'default',   label: 'Crunchbase',       match: 'crunchbase.com',icon: 'CB' },
    { key: 'default',   label: 'The Org',          match: 'theorg.com',    icon: '\u{1F465}' },
    { key: 'default',   label: 'North Data',       match: 'northdata.com', icon: 'N' },
    { key: 'default',   label: 'F6S',              match: 'f6s.com',       icon: 'F6' }
  ];

  /* ─── i18n (injected from Liquid via window.__SK_AUTHOR_I18N) ─── */
  var T = window.__SK_AUTHOR_I18N || {};

  /* ─── Role icons mapping ─── */
  var ROLE_ICONS = {
    'Geschäftsführer':        '\u{1F3E2}',
    'Sachverständiger':       '\u{1F50D}',
    'Buchautor':              '\u{1F4DA}',
    'Gastdozent':             '\u{1F393}',
    'EIT Juror':              '\u{2696}',
    'Seriengründer':          '\u{1F680}',
    'Investor':               '\u{1F4B0}'
  };

  /* ─── Language flags ─── */
  var LANG_FLAGS = {
    'de': '\u{1F1E9}\u{1F1EA}',
    'Deutsch': '\u{1F1E9}\u{1F1EA}',
    'en': '\u{1F1EC}\u{1F1E7}',
    'Englisch': '\u{1F1EC}\u{1F1E7}',
    'fr': '\u{1F1EB}\u{1F1F7}',
    'Französisch': '\u{1F1EB}\u{1F1F7}'
  };

  function detectPlatform(url) {
    var lower = (url || '').toLowerCase();
    for (var i = 0; i < PLATFORMS.length; i++) {
      if (lower.indexOf(PLATFORMS[i].match) !== -1) return PLATFORMS[i];
    }
    return { key: 'default', label: extractDomain(url), match: '', icon: '\u{1F517}' };
  }

  function extractDomain(url) {
    try {
      var h = new URL(url).hostname.replace('www.', '');
      return h.charAt(0).toUpperCase() + h.slice(1);
    } catch (e) {
      return 'Link';
    }
  }

  /* ─── Helpers ─── */
  function esc(str) {
    if (!str) return '';
    var d = document.createElement('div');
    d.textContent = String(str);
    return d.innerHTML;
  }

  function toArray(val) {
    if (!val) return [];
    return Array.isArray(val) ? val : [val];
  }

  function extractYear(dateStr) {
    if (!dateStr) return '';
    var m = String(dateStr).match(/\d{4}/);
    return m ? m[0] : '';
  }

  function getOrgName(org) {
    if (!org) return '';
    if (typeof org === 'string') return org;
    return org.name || org.legalName || '';
  }

  function formatMoney(amount) {
    if (!amount) return '';
    var val = amount.value || amount;
    var cur = amount.currency || 'EUR';
    if (typeof val !== 'number') val = parseFloat(val);
    if (isNaN(val)) return '';
    return val.toLocaleString('de-DE') + ' ' + cur;
  }

  function el(id, sectionId) {
    return document.getElementById(id + '-' + sectionId);
  }

  /* ─── Counter animation ─── */
  function animateCounter(element, target, suffix) {
    if (!element || target <= 0) return;
    var duration = 1200;
    var startTime = null;
    suffix = suffix || '';

    function step(ts) {
      if (!startTime) startTime = ts;
      var progress = Math.min((ts - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      element.textContent = Math.round(eased * target) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }

    element.dataset.target = target;
    requestAnimationFrame(step);
  }

  /* ─── Main init ─── */
  function initAuthorProfile(sectionEl) {
    if (!sectionEl) return;
    var sectionId = sectionEl.dataset.sectionId;
    if (!sectionId) return;

    var schemaScript = document.getElementById('author-schema-data-' + sectionId);
    var data = null;

    if (schemaScript) {
      try {
        var raw = schemaScript.textContent;
        /* Shopify outputs metaobject JSON fields as Ruby hashes (=> instead of :).
           Convert to valid JSON before parsing. */
        if (raw.indexOf('=>') !== -1) {
          raw = raw.replace(/=>/g, ':');
        }
        data = JSON.parse(raw);
      } catch (e) {
        console.warn('Author Profile: JSON-LD parse error', e);
      }
    }

    if (!data) {
      var placeholders = sectionEl.querySelectorAll('.author-profile__placeholder');
      for (var i = 0; i < placeholders.length; i++) {
        placeholders[i].textContent = T.no_data || 'Keine Daten verfügbar.';
      }
      initReveal(sectionEl);
      return;
    }

    /* Extract all arrays */
    var credentials = toArray(data.hasCredential);
    var alumniOf = toArray(data.alumniOf);
    var founders = toArray(data.founder);
    var funderOrgs = toArray(data.funder);
    var worksFor = toArray(data.worksFor);
    var awards = toArray(data.award);
    var memberOf = toArray(data.memberOf);
    var knowsAbout = toArray(data.knowsAbout);
    var sameAs = toArray(data.sameAs);
    var performerIn = toArray(data.performerIn);
    var occupations = toArray(data.hasOccupation);
    var languages = toArray(data.knowsLanguage);
    var jobTitles = toArray(data.jobTitle);

    /* ─── Hero ─── */
    var nameEl = el('ap-name', sectionId);
    var jobEl = el('ap-jobtitle', sectionId);
    var introEl = el('ap-intro', sectionId);
    var heroImg = el('ap-hero-img', sectionId);

    if (nameEl && data.name) nameEl.textContent = data.name;
    if (jobEl && jobTitles.length > 0) jobEl.textContent = jobTitles.join(' | ');

    if (heroImg && data.image && !heroImg.src) {
      var imgUrl = typeof data.image === 'string' ? data.image : (data.image.url || data.image.contentUrl || '');
      if (imgUrl) {
        heroImg.src = imgUrl;
        heroImg.alt = data.name || '';
      }
    }

    /* TÜV Badge */
    var tuevCred = null;
    for (var i = 0; i < credentials.length; i++) {
      var cName = (credentials[i].name || '').toLowerCase();
      var cIssuer = getOrgName(credentials[i].recognizedBy).toLowerCase();
      if (cName.indexOf('t\u00fcv') !== -1 || cIssuer.indexOf('t\u00fcv') !== -1) {
        tuevCred = credentials[i];
        break;
      }
    }
    var tuevBadge = el('ap-tuev-badge', sectionId);
    var tuevText = el('ap-tuev-badge-text', sectionId);
    if (tuevBadge && tuevCred) {
      tuevBadge.style.display = 'flex';
      if (tuevText) tuevText.textContent = T.tuev_certified || 'TÜV-geprüft';
    }

    /* ─── Credentials Bar ─── */
    var credCount = credentials.length + alumniOf.length;
    var awardCount = awards.length;
    /* Extract book count from occupations */
    var bookCount = 50;
    for (var i = 0; i < occupations.length; i++) {
      var desc = occupations[i].description || '';
      var bookMatch = desc.match(/(\d+)\s*Sachb/i);
      if (bookMatch) { bookCount = parseInt(bookMatch[1], 10); break; }
    }
    var productCount = 500;

    var statCred = el('ap-stat-credentials', sectionId);
    var statAward = el('ap-stat-awards', sectionId);
    var statBooks = el('ap-stat-books', sectionId);
    var statProducts = el('ap-stat-products', sectionId);

    if (statCred) statCred.dataset.target = credCount;
    if (statAward) statAward.dataset.target = awardCount;
    if (statBooks) { statBooks.dataset.target = bookCount; statBooks.dataset.suffix = '+'; }
    if (statProducts) { statProducts.dataset.target = productCount; statProducts.dataset.suffix = '+'; }

    /* ─── Sidebar: Roles & Tätigkeiten ─── */
    var rolesCard = el('ap-roles-card', sectionId);
    var rolesEl = el('ap-roles', sectionId);
    if (rolesEl && occupations.length > 0) {
      rolesCard.style.display = 'block';
      var html = '';
      for (var i = 0; i < occupations.length; i++) {
        var occ = occupations[i];
        var occName = occ.name || '';
        var occDesc = occ.description || '';
        var occLoc = '';
        if (occ.occupationLocation) {
          occLoc = typeof occ.occupationLocation === 'string'
            ? occ.occupationLocation
            : (occ.occupationLocation.name || getOrgName(occ.occupationLocation) || '');
        }
        /* Find matching icon */
        var icon = '\u{1F4BC}';
        for (var key in ROLE_ICONS) {
          if (occName.indexOf(key) !== -1) { icon = ROLE_ICONS[key]; break; }
        }

        html += '<div class="author-profile__role-item">';
        html += '<div class="author-profile__role-icon">' + icon + '</div>';
        html += '<div class="author-profile__role-info">';
        html += '<div class="author-profile__role-name">' + esc(occName) + '</div>';
        var detail = occLoc || occDesc;
        if (detail) html += '<div class="author-profile__role-detail">' + esc(detail) + '</div>';
        html += '</div></div>';
      }
      rolesEl.innerHTML = html;
    }

    /* ─── Sidebar: Expertise ─── */
    var expertiseCard = el('ap-expertise-card', sectionId);
    var expertiseEl = el('ap-expertise', sectionId);
    if (expertiseEl && knowsAbout.length > 0) {
      expertiseCard.style.display = 'block';
      var html = '';
      for (var i = 0; i < knowsAbout.length; i++) {
        var topic = typeof knowsAbout[i] === 'string' ? knowsAbout[i] : (knowsAbout[i].name || '');
        if (topic) html += '<span class="author-profile__tag">' + esc(topic) + '</span>';
      }
      expertiseEl.innerHTML = html;
    }

    /* ─── Sidebar: Awards (compact) ─── */
    var awardsCard = el('ap-awards-card', sectionId);
    var awardsEl = el('ap-awards', sectionId);
    if (awardsEl && awards.length > 0) {
      awardsCard.style.display = 'block';
      var html = '';
      for (var i = 0; i < awards.length; i++) {
        var award = awards[i];
        var awardName = typeof award === 'string' ? award : (award.name || '');
        var awardYear = typeof award === 'object' ? extractYear(award.startDate || award.date || award.dateReceived) : '';
        var awardAmount = (typeof award === 'object' && award.amount) ? formatMoney(award.amount) : '';

        html += '<div class="author-profile__award-item">';
        if (awardYear) html += '<span class="author-profile__award-year">' + esc(awardYear) + '</span>';
        html += '<div>';
        html += '<span class="author-profile__award-name">' + esc(awardName) + '</span>';
        if (awardAmount) html += '<span class="author-profile__award-amount">' + esc(awardAmount) + '</span>';
        html += '</div></div>';
      }
      awardsEl.innerHTML = html;
    }

    /* ─── Sidebar: Companies ─── */
    var companiesCard = el('ap-companies-card', sectionId);
    var companiesEl = el('ap-companies', sectionId);
    if (companiesEl && (founders.length > 0 || worksFor.length > 0 || funderOrgs.length > 0)) {
      companiesCard.style.display = 'block';
      var html = '';

      for (var i = 0; i < worksFor.length; i++) {
        var org = worksFor[i];
        var name = getOrgName(org);
        if (!name) continue;
        html += buildCompanyItem(name, T.ceo || 'Geschäftsführer', 'active');
      }

      for (var i = 0; i < founders.length; i++) {
        var org = founders[i];
        var name = getOrgName(org);
        if (!name) continue;
        /* Skip if already shown via worksFor */
        if (worksFor.length > 0 && getOrgName(worksFor[0]) === name) continue;
        var status = (org.dissolutionDate || org.status === 'exit') ? 'exit' : 'active';
        html += buildCompanyItem(name, T.founder || 'Gründer', status);
      }

      for (var i = 0; i < funderOrgs.length; i++) {
        var org = funderOrgs[i];
        var name = getOrgName(org);
        if (!name) continue;
        var status = org.dissolutionDate ? 'sold' : 'active';
        html += buildCompanyItem(name, T.founding_angel || 'Founding Angel', status);
      }

      companiesEl.innerHTML = html;
    }

    function buildCompanyItem(name, role, status) {
      var initial = name.charAt(0).toUpperCase();
      var statusClass = 'author-profile__company-status--' + status;
      var statusLabel = status === 'active' ? (T.status_active || 'Aktiv') : (status === 'sold' ? (T.status_sold || 'Verkauft') : (T.status_exit || 'Exit'));
      var h = '<div class="author-profile__company-item">';
      h += '<div class="author-profile__company-logo">' + esc(initial) + '</div>';
      h += '<div class="author-profile__company-info">';
      h += '<div class="author-profile__company-name">' + esc(name) + '</div>';
      h += '<div class="author-profile__company-role">' + esc(role) + '</div>';
      h += '</div>';
      h += '<span class="author-profile__company-status ' + statusClass + '">' + statusLabel + '</span>';
      h += '</div>';
      return h;
    }

    /* ─── Sidebar: Memberships ─── */
    var membershipsCard = el('ap-memberships-card', sectionId);
    var membershipsEl = el('ap-memberships', sectionId);
    if (membershipsEl && memberOf.length > 0) {
      membershipsCard.style.display = 'block';
      var html = '';
      for (var i = 0; i < memberOf.length; i++) {
        var name = getOrgName(memberOf[i]);
        if (name) html += '<div class="author-profile__membership-item">' + esc(name) + '</div>';
      }
      membershipsEl.innerHTML = html;
    }

    /* ─── Sidebar: Languages ─── */
    var languagesCard = el('ap-languages-card', sectionId);
    var languagesEl = el('ap-languages', sectionId);
    if (languagesEl && languages.length > 0) {
      languagesCard.style.display = 'block';
      var html = '';
      for (var i = 0; i < languages.length; i++) {
        var lang = languages[i];
        var langName = typeof lang === 'string' ? lang : (lang.name || '');
        var langCode = typeof lang === 'object' ? (lang.alternateName || '') : '';
        var flag = LANG_FLAGS[langName] || LANG_FLAGS[langCode] || '\u{1F310}';
        if (langName) {
          html += '<div class="author-profile__language-item">';
          html += '<span class="author-profile__language-flag">' + flag + '</span>';
          html += '<span>' + esc(langName) + '</span>';
          html += '</div>';
        }
      }
      languagesEl.innerHTML = html;
    }

    /* ─── Sidebar: Social Links ─── */
    var socialCard = el('ap-social-card', sectionId);
    var socialEl = el('ap-social', sectionId);
    if (socialEl && sameAs.length > 0) {
      socialCard.style.display = 'block';
      var html = '';
      /* Platforms to hide from the frontend */
      var HIDDEN_PLATFORMS = ['northdata.com', 'theorg.com'];
      for (var i = 0; i < sameAs.length; i++) {
        var url = sameAs[i];
        if (typeof url !== 'string') continue;
        var lower = url.toLowerCase();
        var skip = false;
        for (var h = 0; h < HIDDEN_PLATFORMS.length; h++) {
          if (lower.indexOf(HIDDEN_PLATFORMS[h]) !== -1) { skip = true; break; }
        }
        if (skip) continue;
        var plat = detectPlatform(url);
        html += '<a href="' + esc(url) + '" class="author-profile__social-link author-profile__social-link--' + plat.key + '" target="_blank" rel="noopener noreferrer">';
        html += '<span class="author-profile__social-icon">' + esc(plat.icon) + '</span>';
        html += '<span>' + esc(plat.label) + '</span>';
        html += '</a>';
      }
      socialEl.innerHTML = html;
    }

    /* ─── Main: Qualifications (Card Layout) ─── */
    var qualEl = el('ap-qualifications', sectionId);
    if (qualEl && (credentials.length > 0 || alumniOf.length > 0)) {
      var html = '';

      /* Credentials first (certificates, degrees) */
      for (var i = 0; i < credentials.length; i++) {
        var cred = credentials[i];
        var credName = cred.name || '';
        var recognizedBy = toArray(cred.recognizedBy);
        var issuerNames = [];
        for (var j = 0; j < recognizedBy.length; j++) {
          var n = getOrgName(recognizedBy[j]);
          if (n) issuerNames.push(n);
        }
        var issuer = issuerNames.join(', ') || getOrgName(cred.issuedBy) || '';
        var category = cred.credentialCategory || 'Zertifikat';
        var dateStr = extractYear(cred.dateCreated || cred.validFrom);
        var desc = cred.description || '';
        var competencies = toArray(cred.competencyRequired);
        var programName = '';
        if (cred.about && cred.about.name) programName = cred.about.name;

        /* Highlight TÜV and degree credentials */
        var isHighlight = (credName.toLowerCase().indexOf('t\u00fcv') !== -1 ||
                          issuer.toLowerCase().indexOf('t\u00fcv') !== -1 ||
                          category.toLowerCase() === 'degree');

        html += '<div class="author-profile__qual-card' + (isHighlight ? ' author-profile__qual-card--highlight' : '') + '">';
        html += '<div class="author-profile__qual-header">';
        html += '<div class="author-profile__qual-name">' + esc(credName) + '</div>';
        html += '<span class="author-profile__qual-type">' + esc(category) + '</span>';
        html += '</div>';
        if (issuer) html += '<div class="author-profile__qual-issuer">' + esc(issuer) + '</div>';
        if (programName) html += '<div class="author-profile__qual-desc">' + (T.study_program || 'Studiengang:') + ' ' + esc(programName) + '</div>';
        if (desc) html += '<div class="author-profile__qual-desc">' + esc(desc) + '</div>';
        if (dateStr) html += '<div class="author-profile__qual-date">' + esc(dateStr) + '</div>';

        if (competencies.length > 0) {
          html += '<div class="author-profile__qual-competencies">';
          html += '<div class="author-profile__qual-competencies-title">' + (T.competencies || 'Kompetenzbereiche') + '</div>';
          html += '<div class="author-profile__qual-competency-list">';
          for (var j = 0; j < competencies.length; j++) {
            html += '<span class="author-profile__qual-competency">' + esc(competencies[j]) + '</span>';
          }
          html += '</div></div>';
        }
        html += '</div>';
      }

      /* Alumni (universities/programs) – only non-HighSchool */
      for (var i = 0; i < alumniOf.length; i++) {
        var org = alumniOf[i];
        var orgType = org['@type'] || '';
        if (orgType === 'HighSchool') continue;

        var orgName = getOrgName(org);
        if (!orgName) continue;
        var loc = '';
        if (org.address) {
          loc = (org.address.addressLocality || '') + (org.address.addressCountry ? ', ' + org.address.addressCountry : '');
        }
        var orgDesc = org.description || '';
        var isUni = orgType === 'CollegeOrUniversity';
        var typeLabel = isUni ? (T.university || 'Universität') : (T.program || 'Programm');

        html += '<div class="author-profile__qual-card">';
        html += '<div class="author-profile__qual-header">';
        html += '<div class="author-profile__qual-name">' + esc(orgName) + '</div>';
        html += '<span class="author-profile__qual-type">' + esc(typeLabel) + '</span>';
        html += '</div>';
        if (loc) html += '<div class="author-profile__qual-issuer">' + esc(loc) + '</div>';
        if (orgDesc) html += '<div class="author-profile__qual-desc">' + esc(orgDesc) + '</div>';
        html += '</div>';
      }

      qualEl.innerHTML = html;
    } else if (qualEl) {
      qualEl.innerHTML = '<p class="author-profile__placeholder">' + (T.no_qualifications || 'Keine Qualifikationen hinterlegt.') + '</p>';
    }

    /* ─── Main: Awards Detail ─── */
    var awardsDetailSection = el('ap-awards-detail-section', sectionId);
    var awardsDetailEl = el('ap-awards-detail', sectionId);
    if (awardsDetailEl && awards.length > 0) {
      awardsDetailSection.style.display = 'block';
      var html = '';

      /* Sort by date descending */
      var sorted = awards.slice().sort(function (a, b) {
        var yA = extractYear(a.startDate || a.date) || '0000';
        var yB = extractYear(b.startDate || b.date) || '0000';
        return yB.localeCompare(yA);
      });

      for (var i = 0; i < sorted.length; i++) {
        var award = sorted[i];
        var name = typeof award === 'string' ? award : (award.name || '');
        var year = typeof award === 'object' ? extractYear(award.startDate || award.date) : '';
        var desc = typeof award === 'object' ? (award.description || '') : '';
        var funderName = '';
        if (typeof award === 'object' && award.funder) {
          funderName = getOrgName(award.funder);
        }
        var amount = (typeof award === 'object' && award.amount) ? formatMoney(award.amount) : '';
        var hasMoney = !!amount;

        html += '<div class="author-profile__award-detail-card' + (hasMoney ? ' author-profile__award-detail-card--money' : '') + '">';
        if (year) html += '<div class="author-profile__award-detail-year">' + esc(year) + '</div>';
        html += '<div class="author-profile__award-detail-content">';
        html += '<div class="author-profile__award-detail-name">' + esc(name) + '</div>';
        if (desc) html += '<div class="author-profile__award-detail-desc">' + esc(desc) + '</div>';
        if (funderName) html += '<div class="author-profile__award-detail-funder">' + (T.awarded_by || 'Verliehen von:') + ' ' + esc(funderName) + '</div>';
        if (amount) html += '<div class="author-profile__award-detail-amount">' + esc(amount) + '</div>';
        html += '</div></div>';
      }
      awardsDetailEl.innerHTML = html;
    }

    /* ─── Main: Career Timeline ─── */
    var timelineEl = el('ap-timeline', sectionId);
    if (timelineEl && (founders.length > 0 || funderOrgs.length > 0)) {
      /* Combine founders + funder into one timeline */
      var items = [];
      for (var i = 0; i < founders.length; i++) {
        items.push({ org: founders[i], role: T.founder_ceo || 'Gründer & Geschäftsführer', type: 'founder' });
      }
      for (var i = 0; i < funderOrgs.length; i++) {
        items.push({ org: funderOrgs[i], role: T.founding_angel || 'Founding Angel', type: 'funder' });
      }

      /* Sort by founding date descending */
      items.sort(function (a, b) {
        var yA = extractYear(a.org.foundingDate) || '0000';
        var yB = extractYear(b.org.foundingDate) || '0000';
        return yB.localeCompare(yA);
      });

      var html = '';
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var org = item.org;
        var name = getOrgName(org);
        var year = extractYear(org.foundingDate);
        var endYear = extractYear(org.dissolutionDate);
        var desc = org.description || '';
        var dateRange = year;
        if (endYear) dateRange += ' \u2013 ' + endYear;
        else if (year) dateRange += ' \u2013 ' + (T.today || 'heute');

        /* Status */
        var status = '';
        var statusClass = '';
        if (org.dissolutionDate) {
          if (item.type === 'funder' || desc.toLowerCase().indexOf('verkauft') !== -1) {
            status = T.status_sold || 'Verkauft';
            statusClass = 'author-profile__timeline-status--sold';
          } else {
            status = T.status_exit || 'Exit';
            statusClass = 'author-profile__timeline-status--exit';
          }
        } else {
          status = T.status_active || 'Aktiv';
          statusClass = 'author-profile__timeline-status--active';
        }

        html += '<div class="author-profile__timeline-item">';
        html += '<div class="author-profile__timeline-dot"></div>';
        if (dateRange) html += '<div class="author-profile__timeline-date">' + esc(dateRange) + '</div>';
        html += '<div class="author-profile__timeline-title">' + esc(name) + '</div>';
        if (desc) html += '<div class="author-profile__timeline-desc">' + esc(desc) + '</div>';
        html += '<span class="author-profile__timeline-role">' + esc(item.role) + '</span>';
        html += '<span class="author-profile__timeline-status ' + statusClass + '">' + esc(status) + '</span>';
        html += '</div>';
      }
      timelineEl.innerHTML = html;
    } else if (timelineEl) {
      timelineEl.innerHTML = '<p class="author-profile__placeholder">' + (T.no_career || 'Kein Werdegang hinterlegt.') + '</p>';
    }

    /* ─── Main: Media / PerformerIn ─── */
    var mediaSection = el('ap-media-section', sectionId);
    var mediaEl = el('ap-media', sectionId);
    if (mediaEl && performerIn.length > 0) {
      mediaSection.style.display = 'block';
      var html = '';
      for (var i = 0; i < performerIn.length; i++) {
        var event = performerIn[i];
        var eventName = typeof event === 'string' ? event : (event.name || '');
        var eventType = '';
        var eventDesc = '';
        var producer = '';

        if (typeof event === 'object') {
          eventType = event['@type'] || '';
          if (eventType === 'TVSeries') eventType = T.tv_show || 'TV-Sendung';
          eventDesc = event.description || '';
          if (event.productionCompany) {
            producer = getOrgName(event.productionCompany);
          }
        }

        html += '<div class="author-profile__media-card">';
        if (producer) html += '<div class="author-profile__media-type">' + esc(producer) + '</div>';
        html += '<div class="author-profile__media-name">' + esc(eventName) + '</div>';
        if (eventDesc) html += '<div class="author-profile__media-location">' + esc(eventDesc) + '</div>';
        html += '</div>';
      }
      mediaEl.innerHTML = html;
    }

    /* ─── Bio from schema (dynamic) ─── */
    var bioContainer = el('ap-bio-container', sectionId);
    var bioSchema = el('ap-bio-schema', sectionId);
    if (bioContainer && data.description) {
      if (bioSchema) bioSchema.textContent = data.description;

      /* Generate extended bio from JSON-LD data */
      var extBio = '';

      /* Occupation-based bio paragraph */
      if (occupations.length > 0) {
        var occParts = [];
        for (var i = 0; i < occupations.length; i++) {
          var occ = occupations[i];
          if (occ.description) occParts.push(occ.description);
        }
        if (occParts.length > 0) {
          extBio += '<p class="author-profile__bio-text">' + esc(occParts.join(' ')) + '</p>';
        }
      }

      /* Education-based paragraph */
      var eduParts = [];
      for (var i = 0; i < alumniOf.length; i++) {
        var org = alumniOf[i];
        if (org['@type'] === 'HighSchool') continue;
        var desc = org.description || '';
        if (desc) eduParts.push(desc);
      }
      if (eduParts.length > 0) {
        extBio += '<p class="author-profile__bio-text">' + esc(eduParts.join(' ')) + '</p>';
      }

      if (extBio) bioContainer.insertAdjacentHTML('beforeend', extBio);
    }

    /* ─── Quote from schema (dynamic) ─── */
    var quoteSection = el('ap-quote-section', sectionId);
    var quoteText = el('ap-quote-text', sectionId);
    var quoteCiteEl = el('ap-quote-cite', sectionId);
    if (quoteSection && data.citation) {
      quoteSection.style.display = 'block';
      if (quoteText) quoteText.textContent = data.citation;
      if (quoteCiteEl) quoteCiteEl.textContent = '\u2014 ' + (data.name || '');
    } else if (quoteSection && data.description && data.name) {
      /* Fallback: use a generated quote from the description's first sentence */
      var firstSentence = data.description.split('. ')[0];
      if (firstSentence && firstSentence.length > 50) {
        quoteSection.style.display = 'block';
        if (quoteText) quoteText.textContent = firstSentence + '.';
        if (quoteCiteEl) quoteCiteEl.textContent = '\u2014 ' + data.name;
      }
    }

    /* ─── Init scroll reveal & counter animations ─── */
    initReveal(sectionEl);
  }

  /* ─── Scroll Reveal & Counter Animation ─── */
  function initReveal(sectionEl) {
    if (!('IntersectionObserver' in window)) {
      var items = sectionEl.querySelectorAll('.reveal-item');
      for (var i = 0; i < items.length; i++) items[i].classList.add('revealed');
      var counters = sectionEl.querySelectorAll('.author-profile__stat-number');
      for (var i = 0; i < counters.length; i++) {
        animateCounter(counters[i], parseInt(counters[i].dataset.target, 10) || 0, counters[i].dataset.suffix || '');
      }
      return;
    }

    var countersAnimated = false;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');

          if (!countersAnimated && entry.target.classList.contains('author-profile__stat')) {
            countersAnimated = true;
            var counters = sectionEl.querySelectorAll('.author-profile__stat-number');
            for (var i = 0; i < counters.length; i++) {
              animateCounter(counters[i], parseInt(counters[i].dataset.target, 10) || 0, counters[i].dataset.suffix || '');
            }
          }

          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    var items = sectionEl.querySelectorAll('.reveal-item');
    for (var i = 0; i < items.length; i++) {
      observer.observe(items[i]);
    }

    /* ─── "Mehr laden" Button ─── */
    var loadMoreBtn = sectionEl.querySelector('[data-ap-load-more]');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        var batchSize = parseInt(loadMoreBtn.dataset.batchSize, 10) || 6;
        var hidden = sectionEl.querySelectorAll('.ap-article--hidden:not(.ap-article--visible)');
        var count = Math.min(batchSize, hidden.length);
        for (var j = 0; j < count; j++) {
          (function (el, delay) {
            setTimeout(function () {
              el.classList.add('ap-article--visible');
              observer.observe(el);
            }, delay * 80);
          })(hidden[j], j);
        }
        var remaining = hidden.length - count;
        if (remaining <= 0) {
          loadMoreBtn.closest('.author-profile__articles-more').style.display = 'none';
        }
      });
    }
  }

  /* ─── Initialize on DOM ready ─── */
  function initAll() {
    var sections = document.querySelectorAll('.author-profile');
    for (var i = 0; i < sections.length; i++) {
      initAuthorProfile(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ─── Shopify Theme Editor Support ─── */
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.author-profile');
    if (section) initAuthorProfile(section);
  });

  document.addEventListener('shopify:section:unload', function () {});
})();
